import React from "react"
import types from "prop-types"
import clsx from "clsx"

const TaskDueDate = ({ dueDate, isOverdue }) => (
  <span className={clsx(
    isOverdue && "overdue-date",
    "w-24 p-1 text-token text-dark font-semibold",
  )}
  >
    { dueDate }
  </span>
)

TaskDueDate.propTypes = {
  dueDate: types.string.isRequired,
  isOverdue: types.bool.isRequired,
}

export default TaskDueDate
